import {
  UPDATE_FILTER,
  GET_SALES_EVENTS_REQUESTED,
  GET_SALES_EVENTS_SUCCEEDED,
  GET_SALES_EVENTS_FAILED,
  UPDATE_SALES_EVENT_REQUESTED,
  UPDATE_SALES_EVENT_SUCCEEDED,
  UPDATE_SALES_EVENT_FAILED,
} from './constants'
import api from '../../utils/api'

export const updateFilter = (key, value) => ({
  type: UPDATE_FILTER,
  payload: { key, value }
})

export const getSalesEventsRequested = () => ({
  type: GET_SALES_EVENTS_REQUESTED
})

export const getSalesEventsSucceeded = (payload) => ({
  type: GET_SALES_EVENTS_SUCCEEDED,
  payload
})

export const getSalesEventsFailed = () => ({
  type: GET_SALES_EVENTS_FAILED
})

export const updateSalesEventRequested = () => ({
  type: UPDATE_SALES_EVENT_REQUESTED
})

export const updateSalesEventSucceeded = (payload) => ({
  type: UPDATE_SALES_EVENT_SUCCEEDED,
  payload
})

export const updateSalesEventFailed = () => ({
  type: UPDATE_SALES_EVENT_FAILED
})

export const loadSalesEvents = venueUuid => dispatch => {
  dispatch(getSalesEventsRequested())

  return api
    .fetchSalesEvents(venueUuid)
    .then(response => dispatch(getSalesEventsSucceeded(response.data.salesEvents)))
    .catch(() => dispatch(getSalesEventsFailed()))
}

export const updateSalesEvent = (params) => dispatch => {
  dispatch(updateSalesEventRequested)

  return api
    .updateSalesEvent(params)
    .then(response => dispatch(updateSalesEventSucceeded(response.data.salesEvents)))
    .catch(() => dispatch(updateSalesEventFailed()))
}
